import Notifier from 'common/helpers/Notifier';
import { isEmpty } from 'lodash';
import {
  SET_NETWORK_BROWSE_GROUPS_FETCHING,
  UNSET_NETWORK_BROWSE_GROUPS_FETCHING_CASES,
} from 'actions';
import fetchCaseProgramBrowseResultsFromSearch from './fetchCaseProgramBrowseResultsFromSearch';

const onError = (error, dispatch) => {
  if (!isEmpty(error.message)) {
    dispatch({
      type: UNSET_NETWORK_BROWSE_GROUPS_FETCHING_CASES,
    });
  }
  Notifier.handleErrors(error);

  return error;
};

const searchNetworkBrowseGroupsForCases = ({
  reqParams,
  additionalProgramIds,
  hint716SearchNetworkHubSupportPremium,
}) => (
  async (dispatch) => {
    try {
      dispatch({
        type: SET_NETWORK_BROWSE_GROUPS_FETCHING,
      });
      const page = {
        page: {
          number: reqParams.page || 1,
          size: reqParams.size || 50,
        },
        sort: reqParams.sort,
      };

      const payload = await fetchCaseProgramBrowseResultsFromSearch({
        ...reqParams.q,
        ...(hint716SearchNetworkHubSupportPremium && { 'provider.type': 'all' }),
      }, page, additionalProgramIds);

      dispatch({
        type: UNSET_NETWORK_BROWSE_GROUPS_FETCHING_CASES,
        payload,
      });

      return payload.data.data;
    } catch (error) {
      return onError(error, dispatch);
    }
  }
);

export default searchNetworkBrowseGroupsForCases;
